export const intakesAccionesRoles = {
  sharedActions: {
    data: [
      'Chief',
      'Admin',
      'IntakeChief',
      'HpsLeader',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
    ],
    box: [
      'Chief',
      'Admin',
      'IntakeChief',
      'HpsLeader',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
      'IntakeOperator',
      'IntakeLeader',
    ],
    pallet: [
      'Chief',
      'Admin',
      'IntakeChief',
      'HpsLeader',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
      'IntakeOperator',
      'IntakeLeader',
    ],
    info: [
      'Chief',
      'Admin',
      'IntakeChief',
      'HpsLeader',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
      'IntakeViewer',
      'Viewer',
      'IntakeOperator',
      'IntakeLeader',
    ],
    report: ['Chief', 'Scanner'],
    validation: ['Chief', 'Admin', 'IntakeChief', 'IntakeLeader'],
    filter: [
      'Chief',
      'Admin',
      'IntakeChief',
      'HpsLeader',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
      'IntakeOperator',
      'IntakeLeader',
    ],
  },

  routerActions: {
    // No hay rutas exclusivas del router
  },

  sideNavActions: {
    reportsPbiIntakes: [
      'Chief',
      'Admin',
      'IntakesAdmin',
      'IntakesChief',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
    ],
    root: [
      'Chief',
      'Admin',
      'IntakesAdmin',
      'IntakesChief',
      'Scanner',
      'ScannerOperators',
      'IntakeKits',
    ],
  },
};
